export default {
	default: [''],
	defaultBg1: ['pill-tabs--bg-1'],
	defaultBg2: ['pill-tabs--bg-2'],
	condensedBg0: ['pill-tabs--condensed--bg-0'],
	condensedBg1: ['pill-tabs--condensed--bg-1'],
	condensedBg2: ['pill-tabs--condensed--bg-2']
};
